<h1 matDialogTitle>
  {{ 'API Key' | translate }}
</h1>
<mat-dialog-content>
  <p>
    {{ 'Success! The API key has been created or reset.' | translate }}
    <strong>{{ 'This is the only time the key is shown.' | translate }}</strong>
  </p>

  <div class="key-section">
    {{ 'API Key:' | translate }}

    <div class="key-value">{{ key }}</div>
  </div>
</mat-dialog-content>

<ix-form-actions matDialogActions>
  <button mat-button ixTest="close" matDialogClose>{{ 'Close' | translate }}</button>

  <button mat-button color="primary" ixTest="copy-to-clipboard" (click)="onCopyPressed()">
    {{ 'Copy to Clipboard' | translate }}
  </button>
</ix-form-actions>
